import type { FunctionComponent, ReactNode } from 'react';

import { useMediaQuery } from '@mantine/hooks';
import { Flex, Title } from '@mantine/core';

import { useMenuPreview } from 'hooks/useMenuManagementMenuPreview';
import { breakpoints } from 'styles/theme.variables';

type MenuBannerProps = {
  hoursButton?: ReactNode;
  editButton?: ReactNode;
};

export const MenuBanner: FunctionComponent<MenuBannerProps> = ({ hoursButton, editButton }) => {
  const { menu } = useMenuPreview();
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);

  return (
    <Flex
      justify={isMobile ? 'flex-start' : 'space-between'}
      align={isMobile ? 'flex-start' : 'center'}
      direction={isMobile ? 'column' : 'row'}
      gap={isMobile ? 'md' : undefined}
      mt="xl2"
      mb="md"
    >
      <Title
        data-cy="checkout-banner__storefront-name"
        order={2}
        style={{ width: isMobile ? '100%' : 'auto' }}
      >
        {menu?.name}
      </Title>
      <Flex gap="xs">
        {hoursButton}
        {editButton}
      </Flex>
    </Flex>
  );
};
